import PropTypes from 'prop-types'
import styled from 'styled-components'
import queryString from 'query-string'

import { px2rem } from '@utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'
import { Icon } from '@mch-group/uikit-components'

const StyledWrapper = styled.div`
  margin-bottom: ${px2rem(40)};
`

const StyledList = styled.li`
  &&& {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(${props => props.rows}, 1fr);
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    grid-gap: ${px2rem(2)};

    > .item {
      padding: 0;
      height: ${px2rem(24)};
      line-height: ${tokensRenamed.lineHeights[6].value};

      &.active {
        display: flex;
        align-items: center;
        font-weight: ${tokens.fontWeights.ivarDisplay3.value};
      }
    }
  }
`

const YearCreatedFilterList = ({ startYear, endYear, selectsChanged, data, rows = 5, columns = 1, title }) => {
  const toggleYear = (yearCode) => {
    const parsedCode = queryString.parse(yearCode)
    let values = [
      { name: 'startYear', value: parsedCode.startYear },
      { name: 'endYear', value: parsedCode.endYear }
    ]
    if (parsedCode.startYear === startYear) {
      values = [
        { name: 'startYear', value: undefined },
        { name: 'endYear', value: undefined }
      ]
    }
    selectsChanged(values)
  }

  const isActive = (yearCode) => {
    const parsedCode = queryString.parse(yearCode)
    return parsedCode.startYear === startYear && parsedCode.endYear === endYear
  }

  return data ? (
    <StyledWrapper>
      <h2 className='h5 mb-4'>{title || 'Year Created'}</h2>
      <StyledList rows={rows} columns={columns}>
        {data.map(year => (
          <span
            className='item'
            key={year.code}
            active={isActive(year.code)}
            onClick={() => toggleYear(year.code)}
            onKeyUp={() => toggleYear(year.code)}
            role='button'
            tabIndex={0}
          >
            {year.value} {isActive(year.code) && <Icon name='checkmark' />}
          </span>
        ))}
      </StyledList>
    </StyledWrapper>
  ) : null
}

YearCreatedFilterList.propTypes = {
  startYear: PropTypes.string,
  endYear: PropTypes.string,
  selectsChanged: PropTypes.func,
  data: PropTypes.array,
  title: PropTypes.string,
  rows: PropTypes.number,
  columns: PropTypes.number
}

export default YearCreatedFilterList
